import { useState } from "react";
import {
  Box,
  CardHeader,
  Dialog,
  Step,
  StepLabel,
  Stepper,
} from "../../../../components";
import AddGradeStepper from "./add-grade-stepper.component";
import { gradeValidator } from "../middlewares";
import { notification, ProdutosService } from "../../../../services";
import { responseErros } from "../../../../utils";

const produtoService = new ProdutosService();

const AddGradeDialog = ({
  id,
  open,
  setOpen,
  activeStep,
  setActiveStep,
  produtosGradeListFiltrados,
  setProdutosGradeListFiltrados,
  produtosGradeList,
  setProdutosGradeList,
  produtosGradeListSelecao,
  setProdutosGradeListSelecao,
  setLoading,
}) => {
  const steps = ["Selecionar Grade", "Inserir Codigo de Barras"];
  const [itensSelecionados, setItensSelecionados] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});

  function handleVoltarStep() {
    setActiveStep(0);
  }
  function handleAvancarStep() {
    const lista = produtosGradeListSelecao.filter((produto) =>
      itensSelecionados.some((id) => produto.id === id)
    );
    setProdutosGradeListFiltrados(lista);
    setActiveStep(1);
  }

  function handleInitAddGrade() {
    setOpen(false);
    setProdutosGradeListSelecao([]);
    setActiveStep(0);
  }

  function handleFormarGrade() {
    gradeValidator
      .validate(produtosGradeListFiltrados, { abortEarly: false })
      .then(async () => {
        setRowModesModel({});
        if (id) {
          const produto = produtosGradeList[0];
          const codigo = produto.codigo.split('.')[0];
          const requestGrade = produtosGradeListFiltrados.map((item, index) => ({
            ...produto,
            ...produto.informacao,
            ...item,
            codigo: `${codigo}.${produtosGradeList.length + index + 1}`,
          }));
          setLoading(true);
          const result = await produtoService.cadastrarListaProdutos(requestGrade);
          if (!result.isAxiosConfig) {
            const resultTemp = result.data.map((item) => ({
              ...item,
              estoqueProduto: { estoque: 0 }
            }));
            setProdutosGradeList((prevState) => [...prevState, ...resultTemp]);
          } else {
            responseErros(result);
          }
          setLoading(false);
        } else setProdutosGradeList(produtosGradeListFiltrados);
        handleInitAddGrade();
      })
      .catch(() => {
        notification.alertaGenericos(
          "Todos os produtos precisam ter Código de Barra"
        );
      });
  }

  return (
    <Dialog fullWidth maxWidth={"md"} open={open} onClose={handleInitAddGrade}>
      <CardHeader title="Produtos em Grade" className="m-2" />
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <AddGradeStepper
        activeStep={activeStep}
        produtosGradeListSelecao={produtosGradeListSelecao}
        handleAvancarStep={handleAvancarStep}
        handleVoltarStep={handleVoltarStep}
        handleCancelarAddGrade={handleInitAddGrade}
        itensSelecionados={itensSelecionados}
        setItensSelecionados={setItensSelecionados}
        produtosGradeListFiltrados={produtosGradeListFiltrados}
        setProdutosGradeListFiltrados={setProdutosGradeListFiltrados}
        rowModesModel={rowModesModel}
        setRowModesModel={setRowModesModel}
        handleFormarGrade={handleFormarGrade}
      />
    </Dialog>
  );
};

export default AddGradeDialog;
